import { Button } from '@nexelem/components';
import { useFormContext } from 'react-hook-form';

type GenerateSimulationButtonProps = {
  variant?: 'contained' | 'outlined';
  submitButtonLabel: string;
};

export const GenerateSimulationButton = ({
  variant = 'contained',
  submitButtonLabel,
}: GenerateSimulationButtonProps) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Button isLoading={isSubmitting} type="submit" variant={variant}>
      {submitButtonLabel}
    </Button>
  );
};
